module.exports = __webpack_public_path__ + "static/EmitWise-82324744e19e781662eb9983b1c05a1a.jpg";